module.exports = __webpack_public_path__ + "img/casentino_unione_logo.1c5e4a7e.png";